/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PetProfileModel } from './PetProfileModel';
import {
    PetProfileModelFromJSON,
    PetProfileModelFromJSONTyped,
    PetProfileModelToJSON,
} from './PetProfileModel';
import type { PetV2FormConfigurationModel } from './PetV2FormConfigurationModel';
import {
    PetV2FormConfigurationModelFromJSON,
    PetV2FormConfigurationModelFromJSONTyped,
    PetV2FormConfigurationModelToJSON,
} from './PetV2FormConfigurationModel';

/**
 * 
 * @export
 * @interface PetConfigV2MetadataModel
 */
export interface PetConfigV2MetadataModel {
    /**
     * 
     * @type {PetV2FormConfigurationModel}
     * @memberof PetConfigV2MetadataModel
     */
    config?: PetV2FormConfigurationModel;
    /**
     * 
     * @type {PetProfileModel}
     * @memberof PetConfigV2MetadataModel
     */
    pet?: PetProfileModel;
}

/**
 * Check if a given object implements the PetConfigV2MetadataModel interface.
 */
export function instanceOfPetConfigV2MetadataModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PetConfigV2MetadataModelFromJSON(json: any): PetConfigV2MetadataModel {
    return PetConfigV2MetadataModelFromJSONTyped(json, false);
}

export function PetConfigV2MetadataModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetConfigV2MetadataModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'config': !exists(json, 'config') ? undefined : PetV2FormConfigurationModelFromJSON(json['config']),
        'pet': !exists(json, 'pet') ? undefined : PetProfileModelFromJSON(json['pet']),
    };
}

export function PetConfigV2MetadataModelToJSON(value?: PetConfigV2MetadataModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'config': PetV2FormConfigurationModelToJSON(value.config),
        'pet': PetProfileModelToJSON(value.pet),
    };
}

